export const formatNumber = (value: number | string | undefined): string => {
    if (!value) return '0';
    const parsedValue = typeof value === 'string' ? parseFloat(value) : value;
    return parsedValue.toLocaleString('en-US');
};
